import React from 'react';

import * as S from './ToggleLogotype.styles';

export interface ToggleLogotypeProps {
  isExpanded?: boolean;
}

export const ToggleLogotype = ({ isExpanded = false }: ToggleLogotypeProps) => {
  const logoPath = `/app/static/images/brand/${
    isExpanded ? 'logo' : 'logo-mini'
  }.svg`;

  return (
    <S.ToggleLogotypeRoot isExpanded={isExpanded}>
      <S.Logo src={logoPath} />
    </S.ToggleLogotypeRoot>
  );
};
